/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Flex,
  Icon,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { SpamOIcon, VirusIcon } from '@tonic-one/react-icons';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalApi } from '@Apis';
import { formatNumberWithUnit } from '@Utils/common';

const EmailAndCollaborationProtection = ({
  setLoading,
}: {
  setLoading: (load: boolean) => void;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const [data, setData] = useState<{
    detectedThreatNum: string;
    scannedMailFileNum: string;
  }>({
    detectedThreatNum: '0',
    scannedMailFileNum: '0',
  });

  useEffect(() => {
    (async function doCall() {
      try {
        setLoading(true);
        const data = (await GlobalApi.getLiveDashboard()).data;
        if (!data) return;
        setData(data);
      } catch (error) {
        console.error('Failed to load live dashboard:', error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      width="100%"
      maxWidth="866px"
      mx="auto"
    >
      {/* Heading */}
      <Box textAlign="center" mb="24px">
        <Text
          fontSize="42px"
          lineHeight="52px"
          color={colorStyle.color.primary}
          fontWeight={400}
        >
          {t(
            'welcome.enableCloudEmailAndCollaborationProtection.heading.part1'
          )}
        </Text>
        <Text
          fontSize="42px"
          lineHeight="52px"
          color={colorStyle.color.primary}
          fontWeight={700}
        >
          {t(
            'welcome.enableCloudEmailAndCollaborationProtection.heading.part2'
          )}
        </Text>
      </Box>

      {/* Statistics */}
      <Flex gap="24px" alignItems="center" mb="24px">
        <Flex flexDirection="column" alignItems="center" textAlign="center">
          <Flex gap="12px" alignItems="center" mb="8px">
            <Icon as={VirusIcon} size="32px" color="white" />
            <Text
              fontSize="20px"
              lineHeight="28px"
              color={colorStyle.color.primary}
            >
              {
                formatNumberWithUnit(data.detectedThreatNum.toString())
                  .dispstring
              }
            </Text>
          </Flex>
          <Text
            fontSize="14px"
            lineHeight="20px"
            color={colorStyle.color.tertiary}
          >
            {t('welcome.enableCloudEmailAndCollaborationProtection.icon1.desc')}
          </Text>
        </Flex>

        <Box width="1px" height="56px" bg="rgba(255, 255, 255, 0.2)" />

        <Flex flexDirection="column" alignItems="center" textAlign="center">
          <Flex gap="12px" alignItems="center" mb="8px">
            <Icon as={SpamOIcon} size="32px" color="white" />
            <Text
              fontSize="20px"
              lineHeight="28px"
              color={colorStyle.color.primary}
            >
              {
                formatNumberWithUnit(data.scannedMailFileNum.toString())
                  .dispstring
              }
            </Text>
          </Flex>
          <Text
            fontSize="14px"
            lineHeight="20px"
            color={colorStyle.color.tertiary}
          >
            {t('welcome.enableCloudEmailAndCollaborationProtection.icon2.desc')}
          </Text>
        </Flex>
      </Flex>

      {/* Description */}
      <Box width="100%" textAlign="left">
        <Box
          as="ul"
          color={colorStyle.color.primary}
          fontSize="14px"
          lineHeight="20px"
          pl="21px"
          m={0}
        >
          <Box as="li" mb="8px">
            <Text>
              {t('welcome.enableCloudEmailAndCollaborationProtection.desc.p1')}
            </Text>
          </Box>
          <Box as="li" mb="8px">
            <Text>
              {t('welcome.enableCloudEmailAndCollaborationProtection.desc.p2')}
            </Text>
          </Box>
          <Box as="li" mb="8px">
            <Text>
              {t('welcome.enableCloudEmailAndCollaborationProtection.desc.p3')}
            </Text>
          </Box>
          <Box as="li">
            <Text>
              {t('welcome.enableCloudEmailAndCollaborationProtection.desc.p4')}
            </Text>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};

export default EmailAndCollaborationProtection;
